var _circle, _rect, _g, _rect2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FF6262"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1936_16233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 8,
    height: 8
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7231,
    y: 4.08251,
    width: 4.67295,
    height: 6.87483,
    rx: 2.33647,
    transform: "rotate(45 12.7231 4.08251)",
    stroke: "black",
    strokeWidth: 1.19875
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1936_16233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6308 7.58441L13.502 2.45557L9.22029 6.73723L14.3491 11.8661L18.6308 7.58441ZM14.3488 11.8665L11.2959 8.8136L9.09019 11.0193L12.1431 14.0722L14.3488 11.8665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1936_16233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 9,
    height: 8
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.53271,
    y: 15.8804,
    width: 4.67295,
    height: 6.87483,
    rx: 2.33647,
    transform: "rotate(-135 7.53271 15.8804)",
    stroke: "black",
    strokeWidth: 1.19875
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1936_16233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62409 12.378L6.75293 17.5068L11.0346 13.2252L5.90576 8.09633L1.62409 12.378ZM5.90604 8.09603L8.95892 11.1489L11.1646 8.9432L8.11175 5.89032L5.90604 8.09603Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic_link.ab69eb6acb0e6ad6c5e982461ff3286d.svg";
export { ForwardRef as ReactComponent };